import { createTheme } from "@mui/material/styles";

export const brandColors = {
  emeraldLight: "#16C79A",
  emeraldDark: "#067A5B",
  tealLight: "#12B886",
  tealDark: "#056150",
  amber: "#FFB627",
  amberLight: "#FFC93C",
  sGreen: "#0A6B52",
  ink: "#113B36",
  inkDark: "#0B2B26",
};

// Almarai has no Latin glyphs at usable weights, so Sanchez (the English
// face) is used for en/he; Arabic gets Almarai to match the mobile apps'
// per-language font swap.
const LANGUAGE_FONTS = {
  en: "Sanchez",
  ar: "Almarai",
};

export function createLandingTheme(direction = "ltr", lang = "en") {
  const languageFont = LANGUAGE_FONTS[lang] || LANGUAGE_FONTS.en;

  return createTheme({
    direction,
    palette: {
      mode: "light",
      primary: {
        main: brandColors.tealLight,
        light: brandColors.emeraldLight,
        dark: brandColors.emeraldDark,
        contrastText: "#ffffff",
      },
      secondary: {
        main: brandColors.amber,
        light: brandColors.amberLight,
        dark: "#C98A12",
        contrastText: brandColors.ink,
      },
      background: {
        default: "#F4FBF8",
        paper: "#FFFFFF",
      },
      text: {
        primary: brandColors.ink,
        secondary: "#4B6B64",
      },
      divider: "rgba(17, 59, 54, 0.08)",
    },
    shape: {
      borderRadius: 16,
    },
    typography: {
      fontFamily: [
        `"${languageFont}"`,
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        "Helvetica",
        "Arial",
        "sans-serif",
      ].join(","),
      h3: { fontWeight: 800 },
      h4: { fontWeight: 800 },
      h5: { fontWeight: 700 },
      h6: { fontWeight: 700 },
      button: { fontWeight: 700 },
    },
    components: {
      MuiStack: {
        defaultProps: {
          // Stack's default spacing uses physical margin-left/-right, which
          // lands on the wrong side under RTL. `gap` is direction-agnostic.
          useFlexGap: true,
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
            borderRadius: 12,
          },
          sizeLarge: {
            paddingTop: 12,
            paddingBottom: 12,
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 12,
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: "none",
          },
        },
      },
    },
  });
}
